import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useParams, useSearchParams } from 'react-router-dom';

import { queryKeys } from '@/shared/constants/queryKeys';
import useBowlingCentersStore from '@/shared/store/bowlingCenters';

import { getBowlingCenter } from '@/services/home';

const useLivescoring = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { uuid } = useParams();
  const { current: currentBC, addCurrentCenter } = useBowlingCentersStore();

  const { data } = useQuery({
    queryKey: [queryKeys.bowlingCenter, uuid],
    queryFn: () => getBowlingCenter(uuid),
    enabled: uuid !== currentBC?.uuid && !!uuid,
  });

  useEffect(() => {
    if (data) {
      addCurrentCenter(data.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleTabChange = (val) => {
    if (val !== 'live') {
      setSearchParams({ ...searchParams, tab: val });
    } else {
      setSearchParams({});
    }
  };

  return {
    currentBC,
    bannerImg: null,
    activeTab: searchParams.get('tab') || 'live',
    handleTabChange,
  };
};

export default useLivescoring;
